// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"MediaRatingLegend_Wrapper__I_yKN","Values":"MediaRatingLegend_Values__44YaK","Value":"MediaRatingLegend_Value__H5w7x","Label":"MediaRatingLegend_Label__hd7uC"};